import React from 'react';
import SocialMediaFeed from '../components/features/SocialMediaFeed';

/** Dedicated, nav-linked page for the YouTube/Instagram cross-promo feed (distinct from the legacy UGC "SocialFeed" page). */
const ZeeSocial = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        position: 'relative',
        background: 'radial-gradient(ellipse at center, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
        color: 'white',
      }}
    >
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          padding: '20px 16px',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ maxWidth: '1280px', margin: '0 auto', width: '100%' }}>
          <p
            style={{
              textAlign: 'center',
              color: '#d1d5db',
              maxWidth: '560px',
              margin: '20px auto 0',
              fontSize: 'clamp(14px, 3.5vw, 15px)',
              padding: '0 8px',
            }}
          >
            Latest videos and posts, all in one place — find Zee on YouTube and Instagram.
          </p>

          <SocialMediaFeed />
        </div>
      </div>
    </div>
  );
};

export default ZeeSocial;
